import CompanyTool from '../tools/CompanyTool'

function cssConf(name)
{
    if (CompanyTool.confFile() && CompanyTool.confFile().style.css && CompanyTool.confFile().style.css[name]) {
        return CompanyTool.confFile().style.css[name]
    }
    return null
}

function isLight(color)
{
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
}

function templateImage(routeName)
{
    const images = CompanyTool.confFile().images
    const exceptionExists = images.exceptions.find((exception) => exception.route == routeName)
    
    if (exceptionExists) {
        if (exceptionExists.type == 'nothing') {
            return null
        } else {
            return exceptionExists.url
        }
    }

    return images.default
}

var StyleTool = {
    cssConf,
    isLight,
    templateImage
}

export default StyleTool



// WEBPACK FOOTER //
// ./src/tools/StyleTool.js